import React from 'react';
import erpIcon from '../../assets/process.png';
import FeatureDetail from './FeatureDetail';

const IntelligentERP = () => {
  const benefits = [
    {
      title: 'Process Automation',
      description: 'Automate routine tasks and workflows to increase efficiency and reduce errors.',
    },
    {
      title: 'Intelligent Insights',
      description: 'AI-driven insights help you identify opportunities and address issues proactively.',
    },
    {
      title: 'Unified Data',
      description: 'Eliminate data silos with a single source of truth across your entire organization.',
    },
    {
      title: 'Adaptive Learning',
      description: 'System learns from user behavior and adapts to improve efficiency over time.',
    },
    {
      title: 'Customizable Workflows',
      description: 'Create workflows that match your business processes exactly, without compromise.',
    },
    {
      title: 'Future-Ready',
      description: 'Continuously evolving platform that adapts to changing business requirements.',
    },
  ];

  const useCases = [
    {
      title: 'Financial Management',
      description: 'Streamline accounting, budgeting, and financial reporting processes.',
    },
    {
      title: 'Human Resources',
      description: 'Manage the entire employee lifecycle from recruitment to retirement.',
    },
    {
      title: 'Customer Relationship',
      description: 'Track customer interactions and manage sales processes effectively.',
    },
    {
      title: 'Project Management',
      description: 'Plan, execute, and monitor projects from inception to completion.',
    },
    {
      title: 'Manufacturing',
      description: 'Optimize production processes, quality control, and resource allocation.',
    },
  ];

  const technologies = [
    { name: 'AI & Machine Learning', icon: '🧠' },
    { name: 'Process Mining', icon: '⛏️' },
    { name: 'RPA', icon: '🤖' },
    { name: 'Natural Language Processing', icon: '💬' },
    { name: 'Advanced Analytics', icon: '📊' },
  ];

  const screenshots = [
    { 
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      caption: 'Intelligent dashboard adapting to user role and preferences'
    },
    { 
      image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      caption: 'Automated workflow management with AI-powered recommendations'
    },
    { 
      image: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      caption: 'Natural language interface for querying business data'
    },
  ];

  return (
    <FeatureDetail
      title="Intelligent ERP"
      subtitle="Drive digital transformation with our AI-powered ERP solutions that adapt to your business needs."
      description={
        <div>
          <p>
            Our Intelligent ERP solution goes beyond traditional ERP systems by incorporating
            artificial intelligence, machine learning, and advanced analytics to create a truly
            adaptive business platform. It doesn't just record your business processes—it helps
            you optimize them.
          </p>
          <p>
            With capabilities that span all departments and functions, our Intelligent ERP serves
            as the digital core of your business, enabling seamless integration, process automation,
            and data-driven decision making across your entire organization.
          </p>
        </div>
      }
      icon={erpIcon}
      benefits={benefits}
      useCases={useCases}
      technologies={technologies}
      mainImage="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
      screenshots={screenshots}
    />
  );
};

export default IntelligentERP;
